













































































import { defineComponent } from '@nuxtjs/composition-api';
import { SfButton, SfImage } from '~/components/StorefrontUi';
import { addBasePath } from '~/helpers/addBasePath';

export default defineComponent({
  name: 'SfNotification',
  components: {
    SfButton,
    SfImage,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    action: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'info',
      validator(value: string) {
        return ['info', 'success', 'warning', 'danger'].includes(
          value,
        );
      },
    },
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'success':
          return 'shield-done-green.svg';
        case 'danger':
          return 'close-square-red.svg';
        case 'warning':
          return 'close-square-orange.svg';
        default:
          return 'info-square.svg';
      }
    },
    colorClass() {
      switch (this.type) {
        case 'info':
          return 'sf-notification--info';
        case 'success':
          return 'sf-notification--success';
        case 'warning':
          return 'sf-notification--warning';
        case 'danger':
          return 'sf-notification--danger';
        default:
          return 'sf-notification--info';
      }
    },
  },
  methods: {
    actionHandler() {
      this.$emit('click:action');
    },
    closeHandler() {
      this.$emit('click:close');
    },
    addBasePath,
  },
});
